import React, { Fragment } from 'react';
import style from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { debounce, addEventListener } from '@ifeng-fe/ui_base';

/**
 * for this page
 */
import NextPage from './nextPage';
import Home from './home';
import LoginBar from './loginBar';
import TipModal from './modal';

class Content extends React.PureComponent {
 
    state = {
        windowHeight: window.innerHeight,
        visible: false
    };

    componentDidMount = () => {
        addEventListener(window, 'resize', debounce(this.getwindowHeight));
    };

    getwindowHeight = () => {
        const windowHeight = window.innerHeight;

        this.setState({
            windowHeight,
        });
    };

    openModal = () => {
        this.setState({
            visible: true
        });
    }

    render() {
        /**
         * 组件分发数据
         */
        const { windowHeight } = this.state;

        return (
            <div className={style.content}>
                <Home windowHeight={windowHeight} openModal={this.openModal} />
                <NextPage windowHeight={windowHeight} />
                <LoginBar windowHeight={windowHeight} openModal={this.openModal} />
                <TipModal
                    visible={this.state.visible} onCancel={() => {
                    this.setState({
                        visible: false
                    });
                }} />
            </div>
        );
    }
}

export default errorBoundary(Content);
